import { render } from "./AppManageAccount.vue?vue&type=template&id=5ed93a4a"
import script from "./AppManageAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./AppManageAccount.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AppManage/AppManageAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ed93a4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ed93a4a', __exports__)) {
    api.reload('5ed93a4a', __exports__)
  }
  
  module.hot.accept("./AppManageAccount.vue?vue&type=template&id=5ed93a4a", () => {
    api.rerender('5ed93a4a', render)
  })

}


export default __exports__